import React from "react";
import { withFormik } from "formik";
import PropTypes from "prop-types";
import BasicInput from "./fields/BasicInput";
import PermissionsSelector from "./fields/PermissionsSelector";
import "../../styles/vendor/react-checkbox-tree.css";
import { Link } from "react-router-dom";

class InnerForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: props.group
        ? props.group.permissions.map(permission => String(permission.id))
        : []
    };

    this._handlePermissionChange = this._handlePermissionChange.bind(this);
  }

  static propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
    setFieldValue: PropTypes.func,
    group: PropTypes.object,
    "group.permissions": PropTypes.array,
    "group.permissions.map": PropTypes.func
  };

  _handlePermissionChange = function(checked) {
    this.setState({ permissions: checked });
    this.props.setFieldValue("permissions", checked);
  };

  render() {
    const { handleSubmit, isSubmitting } = this.props;

    return (
      <form className="m-login__form m-form" onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-xl-6">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-information" />
                    </span>
                    <h3 className="m-portlet__head-text">Group Info</h3>
                  </div>
                </div>
              </div>
              <div className="m-portlet__body">
                <BasicInput
                  {...this.props}
                  name="name"
                  type="text"
                  label="Name"
                  help="Enter a descriptive name for the usergroup you are creating."
                />
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-lock-1" />
                    </span>
                    <h3 className="m-portlet__head-text">Group Permissions</h3>
                  </div>
                </div>
              </div>
              <div className="m-portlet__body">
                <PermissionsSelector
                  onChange={this._handlePermissionChange}
                  name="permissions"
                  default={this.state.permissions}
                  {...this.props}
                />
              </div>
              <div className="m-portlet__foot">
                <div className="row align-items-center">
                  <div className="col-lg-12 m--align-right">
                    <button
                      className={
                        "btn m-btn btn-primary" +
                        (isSubmitting
                          ? " m-btn--custom m-loader m-loader--light m-loader--left"
                          : "")
                      }
                      disabled={isSubmitting}
                    >
                      {this.props.group ? "Update" : "Create"}
                    </button>
                    <span className="m--margin-left-10">
                      or{" "}
                      <Link
                        to="/admin/groups"
                        className="m-link m--font-bold"
                      >
                        Cancel
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const GroupForm = withFormik({
  mapPropsToValues: props => {
    if (props.group) {
      const { group } = props;

      return {
        name: group.name,
        permissions: group.permissions.map(permission => String(permission.id))
      };
    }

    return {
      name: "",
      permissions: []
    };
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.name || values.name === "") {
      errors.name = "required";
    }

    return errors;
  },

  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  }
})(InnerForm);

export default GroupForm;
